<template>
  <div
    class="request"
    :class="{ lightRequest: isDarkMode, darkRequest: !isDarkMode }"
  >
    Don't have a WOLF HQ account?
    <router-link to="/request">Request an account</router-link>
  </div>
</template>

<script>
export default {
  name: "RequestAccount",
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  }
};
</script>

<style lang="scss" scoped>
.request {
  padding-bottom: 20px;
}

.lightRequest {
  color: rgba(255, 255, 255, 0.3);
  a {
    color: $white;
  }
}

.darkRequest {
  color: rgba(0, 0, 0, 0.3);
  a {
    color: $black;
  }
}
</style>
